import React from "react";
import "./activeHiring.css";
import Image1 from "../../assets/noonbikeriders.png";

export default function ActiveHiring() {
 

  return (
    <div className="hiring-aboutUs">
        <div className="hiring-responsive-container-block hiring-bigContainer">
            <div className="hiring-responsive-container-block hiring-Container">
                <div className="hiring-responsive-container-block textSide">
                    <p className="hiring-text-blk heading" >
                        Actively Hiring
                    </p>
                    <p className="hiring-text-blk subHeading">
                        Call now for more deatils about this job vacancy
                    </p>
                    
                    <a href="tel:+971585149878">
                        <button className="hiring-explore"
                        >
                            <span className="callnow">Call Now</span>
                        </button>
                    </a>
                    
                </div>
                <div className="hiring-imgContainer">
                    <img
                        className="hiring-mainImg"
                        src={Image1}
                        alt="Main"
                    />
                </div>
            </div>
        </div>
    </div>
  );
}
